import * as React from "react";

function HiddenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M10.563 16.436c.467.042.947.064 1.437.064 4.694 0 8.5-2.015 8.5-4.5 0-1.213-.906-2.313-2.379-3.122M13.436 7.564A16.019 16.019 0 0012 7.5c-4.694 0-8.5 2.015-8.5 4.5 0 1.212.905 2.312 2.376 3.121"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 5L5 19"
  }));
}

export default HiddenIcon;